/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Icon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Calendar from './Calendar/index'
import Comms from './Comms/index'
import EmployeeWorkHours from './EmployeeWorkHours/index'
import Financial from './Financial/index'
import Kpis from './Kpis/index'
import No from './No/index'
import Notes from './Notes/index'
import Orders from './Orders/index'
import Patient from './Patient/index'
import Patients from './Patients/index'
import React from 'react'
import Reports from './Reports/index'
import Settings from './Settings/index'
import Tasks from './Tasks/index'
import WorkHours from './WorkHours/index'
import Workflows from './Workflows/index'



/** @type {import('Simple/types.js').View} */
export default function Icon({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/Icon",
  selected,
  hovered
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabTypeValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Calendar'}>
<Calendar
  viewPath={`${viewPath}/Calendar`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Comms'}>
<Comms
  viewPath={`${viewPath}/Comms`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patient'}>
<Patient
  viewPath={`${viewPath}/Patient`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patients'}>
<Patients
  viewPath={`${viewPath}/Patients`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Orders'}>
<Orders
  viewPath={`${viewPath}/Orders`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Settings'}>
<Settings
  viewPath={`${viewPath}/Settings`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Reports'}>
<Reports
  viewPath={`${viewPath}/Reports`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Workflows'}>
<Workflows
  viewPath={`${viewPath}/Workflows`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'WorkHours'}>
<WorkHours
  viewPath={`${viewPath}/WorkHours`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'EmployeeWorkHours'}>
<EmployeeWorkHours
  viewPath={`${viewPath}/EmployeeWorkHours`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Financial'}>
<Financial
  viewPath={`${viewPath}/Financial`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Notes'}>
<Notes
  viewPath={`${viewPath}/Notes`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tasks'}>
<Tasks
  viewPath={`${viewPath}/Tasks`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Kpis'}>
<Kpis
  viewPath={`${viewPath}/Kpis`}
 selected={selected}
 hovered={hovered}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}